module.exports = __webpack_public_path__ + "img/INTC.182bcbf9.png";